import { OrderState } from '../../state/order/order.reducer';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  BreakpointObserver,
  Breakpoints,
  LayoutModule,
} from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule, Location } from '@angular/common';
import { ConfirmCoinsDialogComponent } from './confirm-coins-dialog/confirm-coins-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, filter, map, tap } from 'rxjs';
import { Order } from '../../models/Order';
import {
  selectCurrentOrder,
  selectCurrentReflexOrder,
} from '../../state/order/order.selector';
import {
  clearSelectedOrder,
  getReflexOrderById,
  setSelectedOrder,
} from '../../state/order/order.actions';
import { ActivatedRoute } from '@angular/router';
import { Customer } from '../../models/Customer';
import { Comment as AppComment } from '../../models/Comment';
import { getCurrentCustomer } from '../../state/customer/customer.actions';
import { getCustomerByUserName } from '../../state/customer/customer.actions';
import { GatewayOrder } from '../../models/GatewayOrder';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { selectCustomer } from '../../state/customer/customer.selector';

import { OrderWidgetComponent } from './order-widget/order-widget.component';
import { CoinUsageComponent } from './coin-usage/coin-usage.component';
import { OrderCommentsCardComponent } from './order-comments-card/order-comments-card.component';
import { CoinUsageHistoryComponent } from './coin-usage-history/coin-usage-history.component';
import { DualAuthService } from '../../services/DualAuthService';
import { Invoice } from '../../models/Invoice';
import { InvoiceState } from '../../state/invoice/invoice.reducer';
import { selectCurrentInvoice } from '../../state/invoice/invoice.selector';
import { deselectInvoice, selectInvoice } from '../../state/invoice/invoice.actions';
import { CoinTypeState } from '../../state/coin-type/coin-type.reducer';
import { CustomerState } from '../../state/customer/customer.reducer';
import { ContactWidgetComponent } from './contact-widget/contact-widget.component';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-order-details',
  imports: [
    MatGridListModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    OrderWidgetComponent,
    CoinUsageComponent,
    OrderCommentsCardComponent,
    CoinUsageHistoryComponent,
    ContactWidgetComponent,
    LayoutModule,
    PageHeaderComponent,
  ],
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.css',
})
export class OrderDetailsComponent implements OnInit, OnDestroy {
  @Input() coinsUsed: number | null = 0;
  order$: Observable<Order | null>;
  gatewayOrder$: Observable<GatewayOrder | null>;
  customer$: Observable<Customer | null>;
  // invoice$: Observable<Invoice | null>;
  orderId: string = '';
  customerNo: number = 0;

  gridCols = 2;

  constructor(
    private location: Location,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private orderStore: Store<{ order: OrderState }>,
    private breakpointObserver: BreakpointObserver,
    // private invoiceStore: Store<{ invoice: InvoiceState }>,
    private customerStore: Store<{ customer: CustomerState }>,
  ) {
    this.order$ = orderStore.select(selectCurrentOrder);
    this.gatewayOrder$ = orderStore.select(selectCurrentReflexOrder);
    this.customer$ = customerStore.pipe(select(selectCustomer));
    // this.invoice$ = this.invoiceStore.pipe(select(selectCurrentInvoice));

    // this.customer$
    //   .pipe(
    //     filter(customer => !!customer && !!customer.reflexCustomerNo),
    //     tap(customer => {
    //       this.invoiceStore.dispatch(selectInvoice({ orderNo: this.orderId, customerNo: customer!.reflexCustomerNo! }));
    //     })
    //   )
    //   .subscribe();

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe((result) => {
        this.gridCols = result.matches ? 1 : 2;
      });
  }
  ngOnInit(): void {
    this.route.paramMap.subscribe(
      (params) => (this.orderId = params.get('id')!)
    );
    // if (this.auth.isEmployee()) {
    this.orderStore.dispatch(setSelectedOrder({ id: this.orderId }));
    // }
    this.orderStore.dispatch(getReflexOrderById({ id: this.orderId }));
    this.customerStore.dispatch(getCurrentCustomer());
  }

  ngOnDestroy(): void {
    this.orderStore.dispatch(clearSelectedOrder());
    // this.invoiceStore.dispatch(deselectInvoice());
  }

  openConfirmDialog() {
    const dialogRef = this.dialog.open(ConfirmCoinsDialogComponent, {
      data: { coins: this.coinsUsed, orderId: parseInt(this.orderId) },
    });
  }

  back() {
    this.location.back();
  }
}
